import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './css/style.css';
import { Provider } from 'react-redux'
import { createStore  } from 'redux'
import combineReducers from './redux/reducers'
import { loadState, saveState } from './redux/statePersistor';

const store = createStore (combineReducers, loadState(), window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
export let Redux_Global_State = store.getState();
store.subscribe(() => {
  saveState(store.getState())
  Redux_Global_State = store.getState();
})

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
    <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
